






import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'TABLPOZICE',
		};
	},
});
